import React from 'react';
import { QuestionItem } from '../components/QuestionItem';
import { NavigationLink } from '../components/NavigationLink';
import { FooterSection } from '../components/FooterSection';
import { FaqFormDataInterface } from '@src/apps/ContentEditor/Faq/FaqForm/types';
import { FaqDrawerConstants } from '@src/apps/constants/faq-drawer';

interface MostCommonQuestionsViewProps {
  faqItems: FaqFormDataInterface[];
  expandedQuestions: number[];
  onToggleQuestion: (index: number) => void;
  onAllCategoriesClick: () => void;
  onContactUs?: () => void;
}

export const MostCommonQuestionsView: React.FC<MostCommonQuestionsViewProps> = ({
  faqItems,
  expandedQuestions,
  onToggleQuestion,
  onAllCategoriesClick,
  onContactUs
}) => {
  return (
    <>
      <div className="main-title">{FaqDrawerConstants.mostCommonQuestions}</div>

      <div className="questions-list">
        {faqItems.map((item, index) => (
          <QuestionItem
            key={index}
            item={item}
            isExpanded={expandedQuestions.includes(index)}
            onToggle={() => onToggleQuestion(index)}
          />
        ))}
      </div>

      <div className="bottom-section-mostcommon">
        <NavigationLink
          text={FaqDrawerConstants.allCategories}
          onClick={onAllCategoriesClick}
          className="all-categories-link"
        />

        <FooterSection onContactUs={onContactUs} />
      </div>
    </>
  );
};
